import store from "../../store";
import { PNL_EMPTY_VALIDATION, PNL_ERROR, PNL_HIDE_EMPTY_VALIDATION, PNL_HIDE_ERROR, PNL_REPORT, PNL_SHOW_SHIMMER, PNL_STOCK_DETAILS, PNL_STREAM_TOGGLE, PROD_ASSET_FILTER_VAL, } from "../../interfaces/Reports/iPNLReport";
import { UNDERSTANDING_ERROR, UNDERSTANDING_HIDE_ERROR, UNDERSTANDING_SECTION, } from "../../interfaces/Reports/iUnderstandingSection";
import { PNLTXN_EMPTY_VALIDATION, PNLTXN_HIDE_EMPTY_VALIDATION, PNL_TRANSACTION_ERROR, PNL_TRANSACTION_HIDE_ERROR, PNL_TRANSACTION_REPORT, PNL_TRANSACTION_SHOW_SHIMMER, EDIT_SPLIT_TXN_LOADER, PNL_ORIGINAL_TXNS, PNL_ORIGINAL_TXNS_LOADER, STOCK_DETAILS_SUMMARY, } from "../../interfaces/Reports/iPNLTransactionReport";
import { SCREENSTATE } from "@frameworks/web/redux/interfaces/Reports/CoreReports/iHolding";
class PNLReportsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    setEmptyValidationTxn(emptyValidation) {
        this.dispatch({
            type: PNLTXN_EMPTY_VALIDATION,
            payload: emptyValidation,
        });
    }
    hideEmptyValidationTxn() {
        this.dispatch({
            type: PNLTXN_HIDE_EMPTY_VALIDATION,
        });
    }
    setEmptyValidation(emptyValidation) {
        this.dispatch({
            type: PNL_EMPTY_VALIDATION,
            payload: emptyValidation,
        });
    }
    hideEmptyValidation() {
        this.dispatch({
            type: PNL_HIDE_EMPTY_VALIDATION,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: PNL_ERROR,
            payload: {
                errorData: payload,
            },
            errorType,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: PNL_HIDE_ERROR,
            errorType,
        });
    }
    toggleShimmer(shimer) {
        this.dispatch({
            type: PNL_SHOW_SHIMMER,
            payload: {
                showShimmer: shimer,
            },
        });
    }
    toggleTransactionShimmer(shimmer) {
        this.dispatch({
            type: PNL_TRANSACTION_SHOW_SHIMMER,
            payload: {
                showTransactionShimmer: shimmer,
            },
        });
    }
    setViewTransactionReportpErrors(payload, errorType) {
        this.dispatch({
            type: PNL_TRANSACTION_ERROR,
            payload: {
                errorData: payload,
            },
            errorType,
        });
    }
    hideViewTransactionReportpErrors(errorType) {
        this.dispatch({
            type: PNL_TRANSACTION_HIDE_ERROR,
            errorType,
        });
    }
    getPNLReportData(PNLReportEntityList) {
        this.dispatch({
            type: PNL_REPORT,
            payload: {
                data: PNLReportEntityList,
            },
        });
    }
    getPNLTransactionsReportData(data) {
        this.dispatch({
            type: PNL_TRANSACTION_REPORT,
            payload: { data },
        });
    }
    setStockdetails(stockDetails) {
        this.dispatch({
            type: STOCK_DETAILS_SUMMARY,
            payload: { stockDetails },
        });
    }
    setScreenState(screenState, goBackState = false) {
        this.dispatch({
            type: SCREENSTATE,
            payload: { screenState, goBackState },
        });
    }
    getPNLUnderstandingSectionData(understandSection) {
        this.dispatch({
            type: UNDERSTANDING_SECTION,
            payload: { data: understandSection },
        });
    }
    getRealisedUnderstandingSectionData(understandSection) {
        this.dispatch({
            type: UNDERSTANDING_SECTION,
            payload: { data: understandSection },
        });
    }
    getUnrealisedUnderstandingSectionData(understandSection) {
        this.dispatch({
            type: UNDERSTANDING_SECTION,
            payload: { data: understandSection },
        });
    }
    storeSelectedPNLStockDetails(data) {
        this.dispatch({
            type: PNL_STOCK_DETAILS,
            payload: {
                selectedStockDetails: data,
            },
        });
    }
    setErrorUnderStandings(payloadError) {
        this.dispatch({
            type: UNDERSTANDING_ERROR,
            payload: {
                errorData: payloadError,
            },
        });
    }
    hideUnderstandingError() {
        this.dispatch({
            type: UNDERSTANDING_HIDE_ERROR,
        });
    }
    toggleEditSplitPNLTransaction(shimmer) {
        this.dispatch({
            type: EDIT_SPLIT_TXN_LOADER,
            payload: { editTXNShimmer: shimmer },
        });
    }
    saveProdAssetDropDown(prodDropDown) {
        this.dispatch({
            type: PROD_ASSET_FILTER_VAL,
            payload: { prodDropDown: prodDropDown },
        });
    }
    saveStreamToggle(stream) {
        this.dispatch({
            type: PNL_STREAM_TOGGLE,
            payload: { stream: stream },
        });
    }
    pnlOriginalTxn(originalTxns) {
        this.dispatch({
            type: PNL_ORIGINAL_TXNS,
            payload: { pnlOriginalTxns: originalTxns },
        });
    }
    originalTxnLoaderToggle(loader) {
        this.dispatch({
            type: PNL_ORIGINAL_TXNS_LOADER,
            payload: { orgTxnLoader: loader },
        });
    }
}
export default PNLReportsActions;
